import { Link } from 'react-router-dom';
import { Button, cn } from '@/core/ui';

export default function NotFound() {
  return (
    <div
      className={cn(
        'py-4 md:py-8 lg:py-12 px-4 md:px-8',
        'flex flex-1 flex-col justify-center items-center',
        'min-h-full w-full h-screen md:h-auto',
        'bg-gradient-to-l from-primary-300 via-primary-400 to-primary-400',
      )}
    >
      <div className='mx-auto h-auto w-full container'>
        <div className='rounded-xl h-full bg-default-50 shadow-lg flex flex-col px-8 md:px-16 py-10'>
          {/* <div className='flex flex-row items-center space-x-3'>
          <Image alt='logo' width={40} height={40} src='/logo.svg' />
          <h5 className='text-foreground font-medium uppercase text-2xl'>Quesmed</h5>
        </div> */}
          <div className='grid grid-cols-1 h-full lg:grid-cols-2 items-center'>
            <div className='lg:flex hidden col-span-1 justify-end items-end px-12 py-16'>
              <img alt='quesmed brain' width={130} height={130} className='h-auto w-auto' src='/logo.svg' />
            </div>
            <div className='lg:p-10 col-span-1'>
              <div>
                <p className='mb-8 text-5xl md:text-8xl font-semibold tracking-wide text-primary-700 uppercase'>
                  404
                </p>
                <h1 className='mb-4 text-2xl font-extrabold leading-tight tracking-tight text-left text-default-600 md:text-3xl'>
                  Oops! The page you're looking for isn't here.
                </h1>
                <p className='mb-5 text-base text-left text-default-500 md:text-xl'>
                  You might have the wrong address, or the page may have moved.
                </p>
                <Link to='/' className='w-full mb-2 btn btn-lg btn-light sm:w-auto sm:mb-0'>
                  <Button className='bg-primary-700 text-white' size='lg'>
                    Back to homepage
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
